import { TopDeskConnectionIdentifierViewModel } from "client/Api/Apps/EditApp/saveApp";
import { environmentHttpClient as httpClient } from "client/Api/httpClient";

export type IncidentListItem = {
	id: string;
	briefDescription: string;
	number: string;
	processingStatus: string;
	creationDate: string;
	selfServiceUrl: string;
};

export enum IncidentsLoadStatus {
	NoError = 0,
	UnknownError = 1,
	AccessDenied = 2,
	NotConfigured = 3
}

export type IncidentListWithConnection = {
	status: IncidentsLoadStatus;
	items: LazyLoadPageResult<IncidentListItem>;
	connection: TopDeskConnectionIdentifierViewModel;
};

export function listIncidents(
	connections: TopDeskConnectionIdentifierViewModel[]
): Promise<IncidentListWithConnection[]> {
	return httpClient.post<IncidentListWithConnection[]>(
		"Workspace/LiveInformation/TopDesk",
		connections
	);
}
